class ProductSwatch extends HTMLElement {
    connectedCallback() {
        this._resizeSwatch();
        window.addEventListener('resize', this._resizeSwatch);
        this.querySelectorAll('.single-option-selector').forEach((e) => e.addEventListener('change', this._variantChange));

        if(this.querySelector('.single-option-selector[data-name="color"][checked]'))
            this.querySelector('.single-option-selector[data-name="color"][checked]').dispatchEvent(new CustomEvent('change', {detail: "no"}));
        else
            this.querySelector('.single-option-selector[checked]').dispatchEvent(new CustomEvent('change', {detail: "no"}));
    }

    constructor() {
        super();
        this._resizeSwatch = this._resizeSwatch.bind(this);
        this._variantChange = this._variantChange.bind(this);
        this._updateImages = this._updateImages.bind(this);
        this.btn = document.querySelector('#AddToCart');
        this.timer = null;
        this.notify = document.querySelector('notify-bar');
    }

    _variantChange(e){
        let variant = this._getVariantFromOptions();
        variant.parentElement.value = variant.value;
        this._updateImages(variant,e);
        this.btn.querySelector('.btn-inside').innerHTML = window.productStrings.addToCart+'<span class="atc-savings" style="display: none;"></span>';

        if(e.detail!='no')
            this._updateHistoryState(variant);

        this.btn.removeAttribute('redirect');
        clearTimeout(this.timer);
        this.btn.removeEventListener('click',_addCartRedirects);

        if (!variant.disabled) {
            this.btn.classList.add('btn--sold-out');
            this.btn.disable = false;
            this.btn.removeAttribute('disabled');
            this.btn.querySelector('.btn-inside').innerHTML = window.productStrings.addToCart+'<span class="atc-savings" style="display: none;"></span>';
            document.querySelector('.shopify-payment-button').classList.remove('hide');
        } else {
            this.btn.classList.remove('btn--sold-out');
            this.btn.disable = true;
            this.btn.setAttribute('disabled','');
            this.btn.querySelector('.btn-inside').innerHTML = window.productStrings.soldOut;
            document.querySelector('.shopify-payment-button').classList.add('hide');
        }

        this._updatePrice(variant);

        let options = [...this.querySelectorAll(`select option[disabled][data-option1="${variant.dataset['option1']}"]`)];
        if(options.length){
            let s = document.querySelector('.swatch-option.size');
            s.querySelectorAll('input').forEach((i)=>{
                i.parentElement.parentElement.classList.remove('disabled');
                i.removeAttribute('disabled');
                i.disabled = false;
            });
            if(s){
                options.forEach((c)=>{
                    let dd = s.querySelectorAll(`input[value="${c.dataset.option2}"]`);
                    dd.forEach((d)=>{
                        // Keep out-of-stock sizes selectable so picking one triggers the
                        // back-in-stock "Notify me" flow. Only the greyed .disabled visual is
                        // kept; Add to Cart still flips to "Sold out" for the unavailable variant.
                        d.parentElement.parentElement.classList.add('disabled');
                    });
                });
            }
        }
        let form = this.closest('form');
        if(form) {
            let err = form.querySelector('.swatch-option.size .size-error');
            if (form && err) err.style.display = 'none';
        }
    }

    _updateImages(variant,e) {
        var sl = document.querySelector('#image-wrapper .main-slider');
        if (typeof(sl.swiper) !== 'undefined') {
            if (variant && variant.getAttribute('data-featured-media') && (e.target.dataset.name == 'couleur' || e.target.dataset.name == 'color')) {
                var img_id = variant.getAttribute('data-featured-media-id');

                // A/B: default = slide-to, galTest = filter by color
                if (window.galTest !== true) {
                    var imgs = document.querySelector('.product-single-photo[data-image-id="'+img_id+'"]');
                    if (!imgs) return;
                    var parent = imgs.parentNode;
                    var childrenArray = Array.prototype.slice.call(parent.children);
                    var index = childrenArray.indexOf(imgs);
                    if(index < 0) index = 0;
                    if(window.PDPisVariantB === true && index === 1) index = 0;
                    sl.swiper.slideTo(index);
                    return;
                }

                // Variant B: position-based color filtering
                var color = variant.dataset[e.target.dataset.index]
                    .trim().replace(/\s+/g, '-').toLowerCase()
                    .replace(/\//g, '-').replace(/-{2,}/g, '-');
                this._filterByColor(color, img_id);
                return false;
            }
        } else {
            setTimeout(()=>this._updateImages(variant, e), 100);
        }
    }

    /**
     * Position-based color detection.
     * Infographics EXCLUDED — they get cloned into each color by _filterByColor.
     */
    _resolveAllowedIds(color) {
        var mediaList = window._pdpMediaList;
        var colorMap = window._pdpColorMap;
        var colorOrder = window._pdpColorOrder;

        if (!mediaList || !colorMap || !colorOrder || !colorMap[color]) return null;

        var sorted = colorOrder.slice().sort(function(a, b) {
            return colorMap[a].featuredPosition - colorMap[b].featuredPosition;
        });

        var ranges = {};
        for (var i = 0; i < sorted.length; i++) {
            var start = colorMap[sorted[i]].featuredPosition;
            var end = (i < sorted.length - 1) ? colorMap[sorted[i + 1]].featuredPosition - 1 : 999999;
            ranges[sorted[i]] = { start: start, end: end };
        }

        var firstStart = colorMap[sorted[0]].featuredPosition;
        var myRange = ranges[color];
        var ids = [];

        for (var m = 0; m < mediaList.length; m++) {
            var media = mediaList[m];

            // Skip infographics — cloned separately
            if (media.isInfographic) continue;

            if (media.position < firstStart) {
                ids.push(media.id);
                continue;
            }

            if (media.position >= myRange.start && media.position <= myRange.end) {
                ids.push(media.id);
            }
        }

        return ids;
    }

    _filterByColor(color, featuredMediaId) {
        var ids = this._resolveAllowedIds(color);
        if (!ids) return;

        var sl = document.querySelector('#image-wrapper .main-slider');
        var wrapper = sl.querySelector('.swiper-wrapper');
        var thumbWrapper = document.querySelector('.product-thumbs-wrap .swiper-wrapper');
        var thumbSwiper = thumbWrapper.closest('.swiper');

        // Cache originals once
        if (!window._galOriginalSlides) {
            window._galOriginalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
        }
        if (!window._galOriginalThumbs) {
            window._galOriginalThumbs = Array.from(thumbWrapper.querySelectorAll('.swiper-slide'));
        }

        // Build set of infographic media IDs from Liquid data (reliable source)
        if (!window._galInfographicIds) {
            window._galInfographicIds = {};
            var mediaList = window._pdpMediaList || [];
            for (var j = 0; j < mediaList.length; j++) {
                if (mediaList[j].isInfographic) {
                    window._galInfographicIds[mediaList[j].id] = true;
                }
            }
        }

        // Cache infographic templates once
        if (!window._galInfographicTemplates) {
            window._galInfographicTemplates = [];
            window._galInfographicThumbTemplates = [];

            if (window._pdpMetafieldInfographics && window._pdpMetafieldInfographics.length > 0) {
                // Build from metafield URLs
                window._pdpMetafieldInfographics.forEach(function(img, idx) {
                    // Main slide
                    var slide = document.createElement('div');
                    slide.className = 'product-single-photo nobg swiper-slide';
                    slide.setAttribute('data-type', 'image');
                    slide.setAttribute('data-infographic-injected', 'true');
                    slide.setAttribute('data-image-id', 'infographic-mf-' + idx);
                    slide.innerHTML =
                        '<a href="' + img.url1500 + '" class="product-single-photo-link" data-fancybox="pdp-gal">' +
                        '<div class="zoom-wrapper">' +
                        '<img src="' + img.url + '" srcset="' + img.srcset + '" alt="' + img.alt + '" loading="lazy" width="600" height="600">' +
                        '<div class="zoom-icon"><svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"></circle><path d="m21 21-4.35-4.35M8 11h6"></path></svg></div>' +
                        '</div>' +
                        '</a>';
                    window._galInfographicTemplates.push(slide);

                    // Thumb
                    var thumb = document.createElement('div');
                    thumb.className = 'thumb image swiper-slide infogr-pic';
                    thumb.setAttribute('data-type', 'image');
                    thumb.setAttribute('data-image-id', 'infographic-mf-' + idx);
                    thumb.innerHTML =
                        '<div class="inside">' +
                        '<img src="' + img.url + '" alt="' + img.alt + '" loading="lazy" width="56" height="56">' +
                        '</div>';
                    window._galInfographicThumbTemplates.push(thumb);
                });
            } else {
                // Fall back to cloning original #infographics slides
                window._galOriginalSlides.forEach(function(s) {
                    var id = s.getAttribute('data-image-id');
                    if (window._galInfographicIds[id]) {
                        window._galInfographicTemplates.push(s.cloneNode(true));
                    }
                });
                window._galOriginalThumbs.forEach(function(s) {
                    var id = s.getAttribute('data-image-id');
                    if (window._galInfographicIds[id]) {
                        window._galInfographicThumbTemplates.push(s.cloneNode(true));
                    }
                });
            }
        }

        // Pause videos
        wrapper.querySelectorAll('video').forEach(function(v) { v.pause(); });

        // Lock height
        sl.style.minHeight = sl.offsetHeight + 'px';

        // Build allowed set
        var allowed = {};
        for (var i = 0; i < ids.length; i++) allowed[ids[i]] = true;

        // Rebuild main gallery — skip infographic originals
        wrapper.innerHTML = '';
        var featured = null;
        window._galOriginalSlides.forEach(function(slide) {
            var id = slide.getAttribute('data-image-id');
            if (window._galInfographicIds[id]) return;
            if (allowed[id]) {
                wrapper.appendChild(slide);
                if (id === featuredMediaId) featured = slide;
            }
        });
        if (featured && wrapper.firstChild !== featured) {
            wrapper.insertBefore(featured, wrapper.firstChild);
        }

        // Rebuild thumbs — skip infographic originals
        thumbWrapper.innerHTML = '';
        var featThumb = null;
        window._galOriginalThumbs.forEach(function(slide) {
            var id = slide.getAttribute('data-image-id');
            if (window._galInfographicIds[id]) return;
            if (allowed[id]) {
                thumbWrapper.appendChild(slide);
                if (id === featuredMediaId) featThumb = slide;
            }
        });
        if (featThumb && thumbWrapper.firstChild !== featThumb) {
            thumbWrapper.insertBefore(featThumb, thumbWrapper.firstChild);
        }

        // Inject infographic clones at position 3 (index 2)
        var insertPos = Math.min(2, wrapper.children.length);
        var refSlide = wrapper.children[insertPos] || null;
        var thumbInsertPos = Math.min(2, thumbWrapper.children.length);
        var refThumb = thumbWrapper.children[thumbInsertPos] || null;

        for (var k = 0; k < window._galInfographicTemplates.length; k++) {
            var slideClone = window._galInfographicTemplates[k].cloneNode(true);
            if (refSlide) wrapper.insertBefore(slideClone, refSlide);
            else wrapper.appendChild(slideClone);

            if (window._galInfographicThumbTemplates[k]) {
                var thumbClone = window._galInfographicThumbTemplates[k].cloneNode(true);
                if (refThumb) thumbWrapper.insertBefore(thumbClone, refThumb);
                else thumbWrapper.appendChild(thumbClone);
            }
        }

        // Update swipers
        sl.swiper.update();
        thumbSwiper.swiper.update();
        sl.swiper.slideTo(0, 0, false);
        thumbSwiper.swiper.slideTo(0, 0, false);

        // Fancybox re-bind
        wrapper.querySelectorAll('.swiper-slide:not([data-type="video"]) .product-single-photo-link').forEach(function(link) {
            link.setAttribute('data-fancybox', 'pdp-gal');
        });

        // Release height
        requestAnimationFrame(function() { sl.style.minHeight = ''; });
    }

    _resizeSwatch() {
        const options = this.querySelectorAll('.swatch-option.size .options');
        let width = 0;
        options.forEach((e) => {
            e.removeAttribute('style');
            if (e.offsetWidth > width) { width = e.offsetWidth; }
        });
        options.forEach((e) => {
            var mx = 100 / Math.floor(e.closest('.swatch-option').offsetWidth / width);
            e.style.flex = '0 0 ' + mx + '%';
            e.style.maxWidth = mx + '%'
        });
    }

    _getCurrentOptions() {
        let currentOptions = [...this.querySelectorAll('.single-option-selector')].map(function (element) {
            let type = element.getAttribute('type');
            let currentOption = {};
            if (type === 'radio' || type === 'checkbox') {
                if (element.checked) {
                    currentOption.value = element.value;
                    currentOption.index = element.getAttribute('data-index');
                    return currentOption;
                } else { return false; }
            } else {
                currentOption.value = element.value;
                currentOption.index = element.getAttribute('data-index');
                return currentOption;
            }
        });
        currentOptions = currentOptions.filter(x => !!x);
        return currentOptions;
    }

    _getVariantFromOptions () {
        const selectedValues = this._getCurrentOptions();
        let q = '';
        selectedValues.forEach((e)=>{ q += '[data-'+e.index+'="'+e.value+'"]'; });
        return this.querySelector('select option'+q);
    }

    _updatePrice (variant) {
        let current = document.querySelectorAll('.product-info .price .current');
        current.forEach((e)=>{
            let old = e.parentElement.querySelector('.old');
            if(old == null) e.insertAdjacentHTML("afterend","<div class='old'></div>");
        });
        let olds = document.querySelectorAll('.product-info .price .old');
        if (variant) {
            let price = variant.getAttribute('data-price');
            let old_price = variant.getAttribute('data-compare_at_price');

            if(window.showDiscount && variant.getAttribute('data-discount-price'))
                price = variant.getAttribute('data-discount-price');
            if(window.showDiscount && variant.getAttribute('data-discount-compare_at_price'))
                old_price = variant.getAttribute('data-discount-compare_at_price');

            let percent = Math.abs(Math.round((price*100)/old_price - 100));
            let savings = old_price*1 - price*1;

            let high = document.querySelector('.badge-highlight');
            let atcS = document.querySelector('.atc-savings');
            if(atcS) {
                this.btn.setAttribute('data-percent',percent);
                atcS.innerHTML = '<span>|</span>'+window.saveWord+' ' + percent + '%';
            }
            if(high) {
                high.innerHTML = percent + '% off' + '&nbsp; | &nbsp;'+window.saveWord+' ' + document.local.formatMoney(savings, theme.moneyFormat);
            }

            let vars;
            if((vars = sessionStorage.getItem('price-test')) && variant.hasAttribute('data-price-1')){
                if(vars == 1){ price = variant.getAttribute('data-price-1'); old_price = variant.getAttribute('data-compare_at-1'); }
                if(vars == 2){ price = variant.getAttribute('data-price-2'); old_price = variant.getAttribute('data-compare_at-2'); }
            }

            let ap = document.querySelectorAll('.ap-price');
            if(ap.length) ap.forEach((e)=>e.innerHTML = document.local.formatMoney((price/4), theme.moneyFormat));
            let cc = document.querySelectorAll('.product-info .price .current');
            if(cc.length) cc.forEach((e)=>e.innerHTML = document.local.formatMoney(price, theme.moneyFormat));

            olds.forEach((e)=>{
                if (old_price > price) {
                    e.innerHTML = document.local.formatMoney(old_price, theme.moneyFormat);
                    e.classList.remove('hide');
                } else {
                    e.classList.add('hide');
                }
            })
        }
    }

    _updateHistoryState (variant) {
        if (!history.replaceState || !variant) return;
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.value;
        window.history.replaceState({ path: newurl }, '', newurl);
    }
}

customElements.define('product-swatch',ProductSwatch);